import React from 'react';
import Link from 'next/link';
import AppImage from '@/components/ui/AppImage';
import Icon from '@/components/ui/AppIcon';

interface Game {
  id: string;
  title: string;
  category: string;
  plays: number;
  likes: number;
  author: string;
  thumbnail: string;
  thumbnailAlt: string;
  model: string;
}

export default function FeaturedBanner({ game }: { game: Game }) {
  return (
    <div className="relative rounded-2xl overflow-hidden mb-8 h-48 sm:h-64">
      <AppImage
        src={game.thumbnail}
        alt={game.thumbnailAlt}
        fill
        sizes="100vw"
        className="object-cover"
        priority
      />
      <div className="absolute inset-0 bg-gradient-to-r from-black/80 via-black/40 to-transparent" />

      <div className="absolute inset-0 flex items-center px-6 sm:px-10">
        <div className="max-w-lg">
          <div className="flex items-center gap-2 mb-3">
            <span className="text-xs font-semibold px-2.5 py-1 rounded-full gradient-primary text-white">
              ⭐ Em destaque
            </span>
            <span className="text-xs text-white/70">{game.category}</span>
          </div>
          <h2 className="text-2xl sm:text-3xl font-black text-white mb-2">{game.title}</h2>
          <p className="text-sm text-white/70 mb-4">por @{game.author}</p>
          <div className="flex items-center gap-4 mb-5 text-sm text-white/70">
            <span className="flex items-center gap-1.5">
              <Icon name="PlayIcon" size={14} />
              {game.plays.toLocaleString('pt-PT')} jogadas
            </span>
            <span className="flex items-center gap-1.5">
              <Icon name="HeartIcon" size={14} />
              {game.likes} likes
            </span>
          </div>
          <Link
            href="/game-public-page"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-xl text-sm font-semibold text-white gradient-primary hover:opacity-90 active:scale-95 transition-all duration-150"
          >
            <Icon name="PlayIcon" size={15} variant="solid" />
            Jogar agora
          </Link>
        </div>
      </div>
    </div>
  );
}